import { renderRawScore } from "@/utils/ui";
import { useMemo } from "react";

import { INFO, UpwageBadge } from "./upwage-badge";
import { useGetInternalOnlyRender } from "@/hooks/use-internal-only-render";
import { CompetencyFit } from "@/types/screeners";
import type { Nullable } from "@/types/utils";
import { numberIsTruthyOrZero } from "@/utils/helpers";

interface QualifyingBadgeProps {
  rawScore?: string;
  score?: Nullable<number>;
}
export const QualifyingBadge = ({ rawScore, score }: QualifyingBadgeProps) => {
  const internalOnlyRender = useGetInternalOnlyRender();
  const rawScoreUI = renderRawScore(internalOnlyRender, rawScore);
  const isNumber = useMemo(() => numberIsTruthyOrZero(score), [score]);
  const color = useMemo(() => {
    if (!isNumber) {
      return INFO;
    }

    // Casting is safe due to the isNumber check above
    return (score as number) >= 75
      ? CompetencyFit.VeryHigh
      : CompetencyFit.VeryLow;
  }, [isNumber, score]);

  return (
    <UpwageBadge colorVariant={color} filled>
      {isNumber ? `${score}%` : "N/A"}
      {rawScoreUI}
    </UpwageBadge>
  );
};
